import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  xdlColorInfo,
  xdlColorTextSecondary,
  xdlColorInfoSoft,
  scale080,
  scale100,
  scale120,
  scale140,
  spaceXS,
  spaceS,
  spaceM,
  spaceXL,
  spaceXXL,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const QuestionBox = styled.div<{ isOpen: boolean }>`
  align-items: center;
  background-color: ${({ isOpen }) =>
    isOpen ? `${xdlColorInfo}` : `${xdlColorInfoSoft}`};
  cursor: pointer;
  display: flex;
  height: 108px;
  margin: 0 -${scale100} ${spaceXS};
  padding: ${spaceXXL} ${scale100};

  &:hover,
  &:active {
    cursor: pointer;
  }

  @media ${mediaConfined} {
    border-radius: ${scale080};
    height: 96px;
    justify-content: space-between;
    margin: 0 0 ${spaceM};
    padding: ${scale140} ${spaceXXL};
  }
`;

export const Answer = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  margin: ${spaceS} 0 ${scale120};

  @media ${mediaConfined} {
    margin: ${spaceS} ${spaceXXL} ${spaceXL} ${spaceXXL};
  }
`;
